import React from "react";
import { Outlet } from "react-router-dom";
import { Footer } from "../../components/Footer";
import { Navbar } from "../../components/Navbar";
import { ToastContainer } from "../../components/Toast";

export default function MarketingLayout() {
  return (
    <>
      <a href="#main" className="ui-skip-link">
        Skip to content
      </a>
      <Navbar />
      <Outlet />
      <Footer />
      <ToastContainer />
    </>
  );
}
